import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../GenericTableResponse";

export class VATMarginDocument {
  @IsString()
  @Expose()
  id!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  contractorName!: string;
  @IsString()
  @IsOptional()
  @Expose()
  sellerName!: string | null;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsNumber()
  @Expose()
  settlementSentCount!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsBoolean()
  @Expose()
  isSettlementSent!: boolean;
  @IsBoolean()
  @Expose()
  isSettled!: boolean;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean;
  @IsBoolean()
  @Expose()
  canDelete!: boolean;
}

export class VATMarginDocumentResponse extends GenericTableResponse<VATMarginDocument> {
  @Type(() => VATMarginDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<VATMarginDocument>;
}
